import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13.35 14.74a8.22 8.22 0 0 0 3.15-6.487A8.24 8.24 0 0 0 8.053.003C3.59.106-.027 3.828 0 8.3a8.23 8.23 0 0 0 3.168 6.45c.366.287.58.725.582 1.19v.563a1.5 1.5 0 0 0 1.5 1.5h6a1.5 1.5 0 0 0 1.5-1.5v-.563c.001-.472.223-.916.6-1.2M12 21.003a.75.75 0 0 0 0-1.5H4.5a.75.75 0 1 0 0 1.5zm3-12.75a6.76 6.76 0 0 0-6.91-6.75c-3.656.084-6.61 3.13-6.59 6.787a6.72 6.72 0 0 0 2.587 5.278A3 3 0 0 1 5.25 15.94v.563h6v-.563a3.01 3.01 0 0 1 1.172-2.381A6.7 6.7 0 0 0 15 8.253M9.13 3.087a5.23 5.23 0 0 1 4.295 4.284.74.74 0 0 1-.61.872h-.13a.75.75 0 0 1-.74-.618 3.72 3.72 0 0 0-3.058-3.057.75.75 0 0 1 .243-1.481",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }